const media = {
  linkedin: "https://linkedin.com/in/sharmaraj2302",
  github: "https://github.com/dankevil",
  instagram: "https://instagram.com/sharma.raj2302",
  email: "mailto:sharma.raj2302@gmail.com",
  emailRaw: "sharma.raj2302@gmail.com",
  phone: "+91-9588806980"
};

export default media;